import immutableStore from 'utils/immutableStore';
import alt from 'components/Dispatcher';
import {Map, Record, Set} from 'immutable';
import DepartmentFilterActions from 'actions/DepartmentFilterActions';
import cookies from 'js-cookie';
import {deptCookieName} from 'stores/DeptCookieName';

@immutableStore
class DepartmentFilterStore {
  constructor() {
    this.state = Record({
      departmentSubset: Set(), // Set<DepartmentId>
      defaultIds: Set(), // Set<DepartmentId>
      allowedDepartments: Map(), // Map<DepartmentId, Department>
    })();
    this.bindActions(DepartmentFilterActions);
  }

  selectAll() {
    this.setDepartmentIds(this.state.allowedDepartments.keySeq().toSet());
  }

  toggleDepartment(departmentId) {
    const {departmentSubset, allowedDepartments} = this.state;
    if (departmentSubset.equals(Set([departmentId]))) {
      // Don't allow user to deselect the last element
      return;
    }

    if (!allowedDepartments.has(departmentId)) {
      return console.error(`Invalid Department Id: ${departmentId}`);
    }

    if (departmentSubset.get(departmentId)) {
      this.setDepartmentIds(departmentSubset.delete(departmentId));
    } else {
      this.setDepartmentIds(departmentSubset.add(departmentId));
    }
  }

  fetchAllDepartmentsSuccess([defaultIds, departments, isAdmin, overwriteCookie]) {
    const allowedDepartments = isAdmin
      ? departments
      : departments.filter(d => defaultIds.has(d.id));
    const ids = overwriteCookie ? defaultIds : resolveIds(defaultIds, allowedDepartments);

    this.setState({allowedDepartments, defaultIds});
    this.setDepartmentIds(ids);
  }

  fetchAllDepartmentsError(err) {
    console.error(err);
  }

  resetIds() {
    this.setDepartmentIds(this.state.defaultIds);
  }

  /**
   * Sets selected department Ids while keeping the cookie in sync
   */
  setDepartmentIds(newSet) {
    cookies.set(deptCookieName, newSet.join(','), {expires: 1});
    this.setState({departmentSubset: newSet});
  }
}

function resolveIds(defaultIds, allowedDepts) {
  const cookieIds = Set((cookies.get(deptCookieName) || '').split(',')).filter(x => x);
  const ids = cookieIds.isEmpty() ? defaultIds : cookieIds;
  // ensure we don't have ids that aren't in our allowed set
  return ids.filter(id => allowedDepts.has(id));
}

export default alt.createStore(DepartmentFilterStore);
